import { UserInfo } from "@/models";

declare global {
    interface Window {
        appConfig?: Record<string, any>;
        activeUserId?: string;
        userInfo?: UserInfo;
    }
}

export let API_URL: string | null = null;
export let USER_ID: string | null = null;
export let USER_INFO: UserInfo | null = null;

export let config = {
    API_URL: "http://localhost:8000/api",
};

export function setApiUrl(url: string | null) {
    if (url) {
        API_URL = url.includes('/api') ? url : `${url}/api`;
    }
}

export function setUserInfoGlobal(userInfo: UserInfo | null) {
    USER_ID = userInfo?.user_id || null;
    USER_INFO = userInfo;
    window.userInfo = userInfo ?? undefined;
}

export function clearUserInfoGlobal() {
    setUserInfoGlobal(null);
}

export function setEnvData(configData: Record<string, any>) {
    if (configData) {
        config.API_URL = configData.API_URL || "";
    }
}

export function getConfigData() {
    if (!config.API_URL) {
        if (window.appConfig) {
            setEnvData(window.appConfig);
        }
    }
    return { ...config };
}

export function getApiUrl() {
    return "/api";
}

export function getUserInfoGlobal(): UserInfo | null {
    if (!USER_INFO && window.userInfo) {
        setUserInfoGlobal(window.userInfo);
    }
    return USER_INFO;
}

export function getUserId(): string {
    if (!USER_ID) {
        USER_ID = getUserInfoGlobal()?.user_id || null;
    }
    return USER_ID ?? "00000000-0000-0000-0000-000000000000";
}

export default {
    setApiUrl,
    getApiUrl,
    getUserId,
    getConfigData,
    setEnvData,
    config,
    USER_ID,
    API_URL,
};
